// MOBILE DETECT
export function nextScene( sceneData ){
  return {
      type : 'NEXT_SCENE',
      sceneData
  }
}


// WEBPACK FOOTER //
// ./src/actions/sceneManager.js